import { ViewStream } from "spyne";
import { SidebarMenuView } from "./sidebar-menu-view";
import { UtilTraits } from "traits/util-traits";
import { SidebarTraits } from "traits/sidebar-traits";

export class SidebarContainer extends ViewStream {
  constructor(props = {}) {
    props.id = "sidebar-container";
    props.template = require("./templates/sidebar-main.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    /**
    *    "CHANNEL_SIDEBAR_REVEAL_PANEL",
    "CHANNEL_SIDEBAR_HIDE_PANEL",
    "CHANNEL_SIDEBAR_NAVIGATION_EVENT"
    *
    * */

    return [
      ["CHANNEL_SIDEBAR_REVEAL_PANEL", "onRevealSidebar"],
      ["CHANNEL_SIDEBAR_HIDE_PANEL", "onHideSidebar"],
    ];
  }

  getItemIdForReferencePage(routeData) {
    const { pageId, stage, classMethod } = routeData;
    const id = UtilTraits.utils$SanitizeForUrl(`${pageId}-${stage}`);

   //console.log("ITEM ID REF IS ", { id, pageId, stage, routeData });
    return id;
  }

  getItemIdForDocsPage(routeData) {
    const { pageId, section, classMethod } = routeData;
    const id = UtilTraits.utils$SanitizeForUrl(`${pageId}-${section}`);

   //console.log("ITEM ID REF IS ", { id, pageId, routeData });
    return id;
  }

  onRevealSidebar(e) {
    const { menuData, menuType, typeId, pageId, data, exampleId, routeData } =
      e.payload;

    let { itemId } = e.payload;

    /*    if (pageId === 'reference'){
      itemId = this.getItemIdForReferencePage(routeData);
    } else {
      itemId = this.getItemIdForDocsPage(routeData);
    }*/

    itemId = itemId ?? SidebarTraits.sidebar$GetItemIdByRouteData(routeData);

    if (pageId === 'docs'){
      itemId = SidebarTraits.sidebar$GetItemIdByRouteData(routeData);
    }
/*    console.log(
      "REVEAL SIDEBAR ",
      { menuData, menuType, itemId, pageId, data, typeId, exampleId },
      e.payload,
    );*/

    const initPayload = e.payload;

    this.appendView(
      new SidebarMenuView({
        menuType,
        pageId,
        typeId,
        exampleId,
        itemId,
        initPayload,
        data,
      }),
      "#sidebar",
    );

    this.props.el$.addClass("reveal");
  }

  onHideSidebar() {
    this.props.el$.removeClass("reveal");
  }

  onPageChanged(e) {
    const { routeData } = e.payload;
    const { pageId } = routeData;
    const revealSideBar = pageId === "getting-started";

    this.props.el$.toggle("reveal", revealSideBar);

    //console.log('page changed is ',{revealSideBar, pageId, routeData});
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {
    const removeReveal = () => {
      this.props.el$.toggle("reveal");
    };

    /// window.setTimeout(removeReveal, 2000);
    // window.setTimeout(removeReveal, 5000);
    //window.setTimeout(removeReveal, 8000);

    this.addChannel("CHANNEL_SIDEBAR");
  }
}
